<script setup lang="ts">
import { ref, defineProps, defineEmits } from 'vue'
import { myRequest } from '@/utils/fetch'

interface PersonProp {
  personID: number
  firstName: string
  lastName: string
  email: string
}

const props = defineProps<{
  modelValue: boolean
  person: PersonProp
  eventID: number
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void
  (e: 'search-complete'): void
}>()

const loading = ref(false)
const editedFirstName = ref('')
const editedLastName = ref('')

// Set initial values when dialog opens
function onDialogOpen() {
  editedFirstName.value = props.person.firstName
  editedLastName.value = props.person.lastName
}

// Submit LinkedIn search
async function submitUpdate() {
  loading.value = true
  try {
    console.log(props.person.personID, editedFirstName.value, editedLastName.value, props.person.email, props.eventID)
    // Call the API to search for LinkedIn username
    await myRequest('POST', `/ai/update-person/${props.person.personID}`, {
      firstName: editedFirstName.value,
      lastName: editedLastName.value,
      eventID: props.eventID
    })

    // Emit completion event so parent can refresh data
    emit('search-complete')
  } catch (error) {
    console.error('Error searching for LinkedIn profile:', error)
  } finally {
    loading.value = false
    emit('update:modelValue', false)
  }
}

// Close dialog
function closeDialog() {
  emit('update:modelValue', false)
}
</script>

<template>
  <q-dialog
    :model-value="modelValue"
    @update:model-value="(val) => emit('update:modelValue', val)"
    @show="onDialogOpen"
  >
    <q-card style="min-width: 350px">
      <q-card-section>
        <div class="text-h6">Help the AI!</div>
        <div class="text-subtitle2">Update or add the person's name to find the right profile</div>
      </q-card-section>

      <q-card-section>
        <div class="q-mb-md">
          <div class="text-subtitle2">Email</div>
          <div>{{ person.email }}</div>
        </div>

        <q-input v-model="editedFirstName" label="First Name" outlined dense />
        <q-input v-model="editedLastName" label="Last Name" outlined dense class="q-mt-sm" />
      </q-card-section>

      <q-card-actions align="right">
        <q-btn flat label="Cancel" color="negative" @click="closeDialog" />
        <q-btn flat label="Update" color="primary" @click="submitUpdate" :loading="loading" />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>
